import ProxyPromoContent from './ProxyPromoContent';

// Keep original MainContent for future use
// const MainContent = () => {
//     const theme = useTheme();
//     const isTablet = useMediaQuery(theme.breakpoints.down('md'));
//     const headingSize = isTablet ? 'xlarge' : 'xxlarge';
//     const headingLineHeight = isTablet ? 'xsmall' : 'small';

//     return (
//         <section className={styles['main-content']}>
//             <div className={styles['main-content-container']}>
//                 <div className={styles['main-content-heading']}>
//                     <hzn-heading as="h1" size={headingSize} line-height={headingLineHeight}>
//                         Build your inventory from anywhere
//                     </hzn-heading>
//                 </div>
//                 <div className={styles['main-content-image']}>
//                     <img src={HeroImage} alt="Hero" />
//                 </div>
//             </div>
//         </section>
//     );
// };

export default function HeroContent() {
    const version1Props = {
        heading: 'Set bids before auction day',
        content: [
            'Bid early, up to 4 days before the auction',
            'Set bids directly from carmaxauctions.com',
            'Bids are automatically cancelled with any new announcements',
        ],
        isBulletList: true,
    };

    // Keep version2Props for future experiments
    // const version2Props = {
    //     heading: 'Early bidding is now available',
    //     content:
    //         'Set bids up to 4 days before the auction. Bids are automatically cancelled if new announcements are added.',
    //     isBulletList: false,
    // };

    // const getContent = (designNumber: number): JSX.Element => {
    //     switch (designNumber) {
    //         case DESIGN_VERSION_1:
    //             return <ProxyPromoContent {...version1Props} />;
    //         case DESIGN_VERSION_2:
    //             return <ProxyPromoContent {...version2Props} />;
    //         case DESIGN_MAIN:
    //         default:
    //             return <MainContent />;
    //     }
    // };

    return <ProxyPromoContent {...version1Props} />;
}
